import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import TextField from '@mui/material/TextField';
import ReactLoading from 'react-loading';
import mode from './Mode';
import { RetrievePasswordSchema } from '../schemas';
import { useNavigate, useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import '../styles/resetPassword.css';

const ResetPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formMessage, setFormMessage] = useState({ type: '', text: '' });
    const navigate = useNavigate();
    const { state } = useLocation();

    useEffect(() => {
        if (!state || !state.email) {
            navigate('/reset-give-email');
        }
    }, [state, navigate]);

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const onSubmit = () => {
        setIsLoading(true);
        setFormMessage({ type: '', text: '' });
        axios.post(baseurl + 'retrieve-password/', {
            email: state.email,
            password: values.password1
        }).then((resp) => {
            setFormMessage({ type: 'success', text: 'Password has been reset successfully!' });
            setTimeout(() => {
                setIsLoading(false);
                navigate('/login');
            }, 2500);
        }).catch((err) => {
            setFormMessage({ type: 'error', text: 'An error occurred. Please try again.' });
            setIsLoading(false);
        });
    };

    const { values, errors, handleBlur, touched, handleChange, handleSubmit } = useFormik({
        initialValues: {
            password1: '',
            password2: ''
        },
        validationSchema: RetrievePasswordSchema,
        onSubmit
    });

    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/general/' : 'http://127.0.0.1:8000/general/';

    return (
        <div className='reset-password-container'>
            <div className="reset-password-wrapper">
                <div className="reset-password-header">
                    <h1>Set New Password</h1>
                    <p>Create a new password for your account.</p>
                </div>

                <form method="POST" className='reset-password-form' onSubmit={handleSubmit}>
                    {formMessage.text && (
                        <div className={`form-message ${formMessage.type}`}>
                            {formMessage.text}
                        </div>
                    )}
                    <div className='form-group'>
                        <label htmlFor="password">New Password</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.password1 && touched.password1)}
                            id="password"
                            variant="outlined"
                            name='password1'
                            type={showPassword ? 'text' : 'password'}
                            value={values.password1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {errors.password1 && touched.password1 && <p className='error-text'>{errors.password1}</p>}
                    </div>
                    <div className='form-group'>
                        <label htmlFor="confirm-password">Confirm New Password</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.password2 && touched.password2)}
                            id="confirm-password"
                            variant="outlined"
                            name='password2'
                            type={showPassword ? 'text' : 'password'}
                            value={values.password2}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                        />
                        {errors.password2 && touched.password2 && <p className='error-text'>{errors.password2}</p>}
                    </div>

                    <button className="reset-password-btn" type="submit" disabled={isLoading}>
                        {isLoading ? <ReactLoading type="spin" color="#fff" height={25} width={25} /> : "Reset Password"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ResetPassword;